import {
  Beef, ShoppingBasket, UtensilsCrossed, Croissant, Sandwich, Shirt,
  Scale, Receipt, Package, MessageCircle, Printer, Tag, Truck, BarChart3,
  Clock, Users, CreditCard, Smartphone,
} from 'lucide-react';

const BASE = 'https://nfcesys.com.br';

export const SEGMENTS = {
  acougue: {
    slug: 'pdv-para-acougue',
    icon: Beef,
    nome: 'Açougue',
    title: 'Sistema PDV para Açougue com Balança e NFC-e | Fácil e Barato',
    description: 'PDV para açougue fácil e descomplicado: integra com balança, emite NFC-e na SEFAZ, etiquetas de peso e controle de cortes. Melhor custo-benefício. 30 dias grátis, sem cartão.',
    h1a: 'Sistema PDV para',
    h1b: 'Açougue',
    sub: 'Pese na balança, vende no caixa e emite a NFC-e em segundos. Simples de usar, sem complicação e com o melhor custo-benefício do mercado.',
    keywords: ['pdv para açougue', 'sistema para açougue com balança', 'emissor nfc-e açougue', 'programa para açougue'],
    dores: [
      'Perder tempo digitando peso da balança na mão',
      'Etiqueta de peso sem código de barras padronizado',
      'Não saber a margem real de cada corte',
      'Sistema caro, lento e difícil de treinar funcionário',
    ],
    features: [
      { icon: Scale, t: 'Balança integrada', d: 'Leitura automática de peso (Toledo, Filizola, Urano e outras). Zero digitação, zero erro.' },
      { icon: Tag, t: 'Etiquetas de peso', d: 'Imprima etiquetas com código de barras de peso/preço e leia direto no caixa.' },
      { icon: Receipt, t: 'NFC-e homologada', d: 'Cupom fiscal eletrônico emitido na SEFAZ em segundos, com contingência automática.' },
      { icon: Package, t: 'Controle por kg', d: 'Estoque em quilos por corte, com alerta de baixa e relatório de quebra.' },
      { icon: MessageCircle, t: 'Pedidos no WhatsApp', d: 'Bot com IA anota encomendas de churrasco e cortes especiais 24h por dia.' },
      { icon: BarChart3, t: 'Relatórios simples', d: 'Veja o que mais vende, faturamento por dia e margem por produto em um clique.' },
    ],
    depoimentos: [
      { nome: 'Carlos Menezes', negocio: 'Açougue Boi na Brasa', cidade: 'Contagem/MG', texto: 'A balança conversa direto com o caixa. Acabou o erro de digitação e o cupom sai em segundos. Meu funcionário aprendeu em uma tarde.' },
      { nome: 'Rosana Lima', negocio: 'Casa de Carnes Lima', cidade: 'Osasco/SP', texto: 'Pagava três vezes mais no sistema antigo e ele travava toda semana. Aqui é simples, na nuvem e o suporte responde no WhatsApp.' },
      { nome: 'Edilson Prado', negocio: 'Açougue do Edilson', cidade: 'Curitiba/PR', texto: 'As encomendas de churrasco chegam pelo bot do WhatsApp já organizadas. Sábado ficou muito mais tranquilo.' },
    ],
    logos: ['Boi na Brasa', 'Casa de Carnes Lima', 'Açougue do Edilson', 'Frigo Center', 'Carnes Nobres'],
    faq: [
      { q: 'Funciona com a minha balança?', a: 'Sim. Integramos com balanças Toledo, Filizola, Urano, Elgin e a maioria dos modelos com saída serial/USB ou etiqueta com código de barras de peso.' },
      { q: 'Emite NFC-e para açougue?', a: 'Sim, a NFC-e é homologada pela SEFAZ em todos os estados. Você só precisa do certificado digital A1 e do CSC.' },
      { q: 'Preciso de computador potente?', a: 'Não. O sistema roda 100% na nuvem em qualquer computador, notebook ou tablet com internet.' },
    ],
  },
  mercado: {
    slug: 'pdv-para-mercado',
    icon: ShoppingBasket,
    nome: 'Mercado',
    title: 'Sistema PDV para Mercado e Mercearia com NFC-e | Fácil e Completo',
    description: 'Sistema para mercado fácil e descomplicado: caixa rápido com leitor de código de barras, NFC-e homologada, estoque, balança e fiado. Melhor custo-benefício. Teste 30 dias grátis.',
    h1a: 'Sistema PDV para',
    h1b: 'Mercado e Mercearia',
    sub: 'Caixa rápido, estoque sob controle e cupom fiscal automático. Fácil de usar, descomplicado e com preço justo para o pequeno e médio mercado.',
    keywords: ['sistema para mercado', 'pdv para mercearia', 'sistema para minimercado com nfc-e', 'programa para mercadinho'],
    dores: [
      'Fila no caixa por sistema lento ou travando',
      'Estoque desatualizado e produto vencendo na gôndola',
      'Fiado anotado em caderno e sem controle',
      'Mensalidade alta de sistemas complicados',
    ],
    features: [
      { icon: Receipt, t: 'Caixa ultrarrápido', d: 'Leitor de código de barras, atalhos de teclado e NFC-e emitida em segundos.' },
      { icon: Package, t: 'Estoque inteligente', d: 'Entrada por XML da nota, alerta de estoque mínimo e produtos próximos do vencimento.' },
      { icon: Scale, t: 'Balança e hortifrúti', d: 'Pesagem integrada e etiquetas para frios, padaria e hortifrúti.' },
      { icon: Users, t: 'Fiado e clientes', d: 'Contas a receber por cliente, com limite, histórico e cobrança pelo WhatsApp.' },
      { icon: Truck, t: 'Marketplaces e delivery', d: 'Receba pedidos do iFood, Zé Delivery, Rappi e outros direto no sistema.' },
      { icon: BarChart3, t: 'Fechamento de caixa', d: 'Relatórios de vendas, sangria, suprimento e lucro por período em um clique.' },
    ],
    depoimentos: [
      { nome: 'Marcos Tavares', negocio: 'Mercado Bom Preço', cidade: 'Guarulhos/SP', texto: 'Dois caixas rodando ao mesmo tempo e o fechamento sai sozinho. Importei 3 mil produtos pela planilha em minutos.' },
      { nome: 'Juliana Costa', negocio: 'Mercearia da Ju', cidade: 'Belo Horizonte/MG', texto: 'O fiado saiu do caderno. Agora sei quem me deve e o sistema manda o lembrete pelo WhatsApp.' },
      { nome: 'Antônio Ferreira', negocio: 'Mini Mercado Ferreira', cidade: 'Colombo/PR', texto: 'Custo-benefício imbatível. Emite NFC-e, controla estoque e não precisei comprar computador novo.' },
    ],
    logos: ['Mercado Bom Preço', 'Mercearia da Ju', 'Mini Mercado Ferreira', 'Empório Central', 'Super Vizinho'],
    faq: [
      { q: 'Consigo importar meus produtos?', a: 'Sim. Importe por planilha Excel (inclusive arquivos antigos), pelo XML da nota de compra ou migre de sistemas Firebird.' },
      { q: 'Funciona em mais de um caixa?', a: 'Sim. Vários caixas e usuários simultâneos, cada um com sua permissão e fechamento próprio.' },
      { q: 'Tem contrato de fidelidade?', a: 'Não. Você testa 30 dias grátis, sem cartão, e cancela quando quiser.' },
    ],
  },
  restaurante: {
    slug: 'pdv-para-restaurante',
    icon: UtensilsCrossed,
    nome: 'Restaurante',
    title: 'Sistema PDV para Restaurante com NFC-e e Comanda | Fácil de Usar',
    description: 'PDV para restaurante e self-service fácil e descomplicado: comanda, balança por kg, impressão na cozinha, iFood e NFC-e homologada. Melhor custo-benefício. 30 dias grátis.',
    h1a: 'Sistema PDV para',
    h1b: 'Restaurante',
    sub: 'Do self-service por quilo ao à la carte: comandas, cozinha, delivery e cupom fiscal em um sistema simples, sem complicação e com preço que cabe no bolso.',
    keywords: ['sistema para restaurante', 'pdv para self service por quilo', 'sistema de comanda com nfc-e', 'programa para restaurante ifood'],
    dores: [
      'Pedido errado ou esquecido entre salão e cozinha',
      'Balança do self-service sem integração com o caixa',
      'Pedidos do iFood digitados à mão',
      'Sistemas caros e cheios de módulos que ninguém usa',
    ],
    features: [
      { icon: Printer, t: 'Impressão na cozinha', d: 'Pedido sai automaticamente na impressora da cozinha assim que é lançado.' },
      { icon: Scale, t: 'Self-service por kg', d: 'Balança integrada com etiqueta de peso e leitura direta no caixa.' },
      { icon: Truck, t: 'iFood, Rappi, 99Food', d: 'Pedidos dos marketplaces entram no sistema e imprimem na cozinha sozinhos.' },
      { icon: Receipt, t: 'NFC-e e NF-e', d: 'Cupom fiscal para consumidor final e nota fiscal para empresas e eventos.' },
      { icon: MessageCircle, t: 'Cardápio no WhatsApp', d: 'Bot com IA recebe pedidos e reservas 24h e envia o link do cardápio digital.' },
      { icon: Clock, t: 'Rápido de implantar', d: 'Cadastre o cardápio hoje e comece a vender no mesmo dia. Suporte humano incluso.' },
    ],
    depoimentos: [
      { nome: 'Fernanda Rocha', negocio: 'Restaurante Sabor da Serra', cidade: 'São Paulo/SP', texto: 'Self-service por quilo integrado com a balança e o iFood imprimindo direto na cozinha. Reduzi erro de pedido a quase zero.' },
      { nome: 'Rodrigo Alves', negocio: 'Cantina Alves', cidade: 'Betim/MG', texto: 'Trocamos um sistema de R$ 400/mês por um muito mais simples. A equipe aprendeu no mesmo dia.' },
      { nome: 'Patrícia Nunes', negocio: 'Bistrô da Pati', cidade: 'Curitiba/PR', texto: 'Reservas e pedidos chegam pelo WhatsApp com IA. Emito NF-e para empresas em segundos no fim do almoço executivo.' },
    ],
    logos: ['Sabor da Serra', 'Cantina Alves', 'Bistrô da Pati', 'Grill 21', 'Tempero Mineiro'],
    faq: [
      { q: 'Funciona para self-service por quilo?', a: 'Sim. Integra com balança de pesagem e imprime etiqueta ou lança direto na comanda do cliente.' },
      { q: 'Integra com iFood?', a: 'Sim. Você ativa a integração sozinho no painel e os pedidos entram e imprimem na cozinha automaticamente.' },
      { q: 'Preciso de garçom com tablet?', a: 'Não é obrigatório. Funciona no caixa tradicional, e o garçom pode usar celular ou tablet se quiser.' },
    ],
  },
  padaria: {
    slug: 'pdv-para-padaria',
    icon: Croissant,
    nome: 'Padaria',
    title: 'Sistema PDV para Padaria com Balança e NFC-e | Simples e Barato',
    description: 'Sistema para padaria fácil e descomplicado: balança integrada, comanda de mesa, produção própria, NFC-e homologada e controle de estoque. Melhor custo-benefício. 30 dias grátis.',
    h1a: 'Sistema PDV para',
    h1b: 'Padaria e Confeitaria',
    sub: 'Pão por quilo, café da manhã na mesa e encomendas de bolo — tudo em um caixa simples, rápido e com cupom fiscal automático.',
    keywords: ['sistema para padaria', 'pdv para padaria com balança', 'programa para confeitaria', 'emissor nfc-e padaria'],
    dores: [
      'Movimento intenso de manhã e caixa lento',
      'Pesagem de pães e frios sem integração com o caixa',
      'Encomendas de bolos anotadas em papel',
      'Não saber o custo real da produção própria',
    ],
    features: [
      { icon: Scale, t: 'Balança integrada', d: 'Pão, frios e salgados pesados direto no caixa, sem digitar.' },
      { icon: Package, t: 'Produção e insumos', d: 'Ficha técnica: baixa farinha, ovos e fermento automaticamente ao vender o produto.' },
      { icon: Users, t: 'Comanda de mesa', d: 'Controle do café da manhã e lanches por mesa ou cartão de consumo.' },
      { icon: MessageCircle, t: 'Encomendas no WhatsApp', d: 'Bot com IA anota encomendas de bolos e kits festa com data de entrega.' },
      { icon: Receipt, t: 'NFC-e homologada', d: 'Cupom fiscal eletrônico emitido em segundos, com contingência se a SEFAZ cair.' },
      { icon: BarChart3, t: 'Relatório por turno', d: 'Saiba o que vendeu de manhã, tarde e noite e planeje a produção.' },
    ],
    depoimentos: [
      { nome: 'Sérgio Almeida', negocio: 'Padaria Pão Dourado', cidade: 'Santo André/SP', texto: 'Movimento das 6h às 9h sem fila: pão pesado na balança, cupom fiscal automático. O relatório por turno me ajuda a planejar a produção.' },
      { nome: 'Cláudia Reis', negocio: 'Confeitaria Doce Reis', cidade: 'Nova Lima/MG', texto: 'As encomendas de bolo chegam pelo WhatsApp com data de entrega. Nunca mais perdi um pedido anotado em papel.' },
      { nome: 'Luiz Barbosa', negocio: 'Panificadora Barbosa', cidade: 'São José dos Pinhais/PR', texto: 'Ficha técnica baixando os insumos foi um divisor de águas. Sei o custo real de cada produto.' },
    ],
    logos: ['Pão Dourado', 'Doce Reis', 'Panificadora Barbosa', 'Forno & Cia', 'Padaria Estrela'],
    faq: [
      { q: 'Controla a produção própria?', a: 'Sim. Cadastre a ficha técnica dos produtos e o estoque de insumos baixa automaticamente a cada venda.' },
      { q: 'Funciona com etiqueta de peso?', a: 'Sim. Imprime etiqueta com código de barras de peso e preço para frios e pães embalados.' },
      { q: 'Quanto custa?', a: 'Planos a partir de valores acessíveis para o pequeno negócio, sem fidelidade. Teste 30 dias grátis e sem cartão.' },
    ],
  },
  lanchonete: {
    slug: 'pdv-para-lanchonete',
    icon: Sandwich,
    nome: 'Lanchonete',
    title: 'Sistema PDV para Lanchonete e Hamburgueria com NFC-e | Fácil e Rápido',
    description: 'PDV para lanchonete fácil e descomplicado: pedido rápido, impressão na cozinha, iFood integrado, pedidos no WhatsApp e NFC-e homologada. Melhor custo-benefício. 30 dias grátis.',
    h1a: 'Sistema PDV para',
    h1b: 'Lanchonete e Hamburgueria',
    sub: 'Pedido em 3 toques, ticket na chapa e cupom fiscal automático. Um sistema descomplicado, rápido de aprender e com o melhor preço.',
    keywords: ['sistema para lanchonete', 'pdv para hamburgueria', 'sistema para lanchonete com ifood', 'programa para lanchonete'],
    dores: [
      'Pedido anotado errado e cliente reclamando',
      'Delivery do iFood e WhatsApp fora de controle',
      'Fechamento de caixa demorado no fim da noite',
      'Sistema caro com funções que lanchonete não usa',
    ],
    features: [
      { icon: Smartphone, t: 'Pedido em 3 toques', d: 'Tela de produtos com fotos, combos e adicionais. Qualquer atendente aprende em minutos.' },
      { icon: Printer, t: 'Ticket na cozinha', d: 'Cada pedido imprime automaticamente na chapa, sem gritar pedido.' },
      { icon: Truck, t: 'iFood e 99Food', d: 'Pedidos dos apps entram no sistema e imprimem na cozinha sem digitar nada.' },
      { icon: MessageCircle, t: 'Delivery pelo WhatsApp', d: 'Bot com IA recebe pedidos, manda cardápio e confirma endereço 24h.' },
      { icon: Receipt, t: 'NFC-e homologada', d: 'Cupom fiscal eletrônico em segundos, direto na impressora térmica.' },
      { icon: CreditCard, t: 'Pix e cartão', d: 'Registre Pix, débito, crédito e vale-refeição com fechamento de caixa automático.' },
    ],
    depoimentos: [
      { nome: 'Bruno Cardoso', negocio: 'Burger do Bruno', cidade: 'São Paulo/SP', texto: 'Pedido em 3 toques, ticket saindo na chapa e iFood integrado. Fechamento de caixa que levava 40 minutos agora leva 2.' },
      { nome: 'Aline Souza', negocio: 'Lanchonete Ponto Certo', cidade: 'Contagem/MG', texto: 'Simples de verdade. Contratei um atendente novo e ele já estava vendendo em 15 minutos.' },
      { nome: 'Diego Martins', negocio: 'Dog do Diego', cidade: 'Curitiba/PR', texto: 'O bot do WhatsApp anota o delivery com endereço e forma de pagamento. Eu só preparo e entrego.' },
    ],
    logos: ['Burger do Bruno', 'Ponto Certo', 'Dog do Diego', 'Lanches da Praça', 'Smash House'],
    faq: [
      { q: 'Funciona no celular ou tablet?', a: 'Sim. O sistema é 100% na nuvem e roda em computador, tablet ou celular com internet.' },
      { q: 'Integra com iFood?', a: 'Sim. Ative a integração no painel e os pedidos entram e imprimem na cozinha automaticamente.' },
      { q: 'Tem fidelidade?', a: 'Não. Teste 30 dias grátis, sem cartão, e cancele quando quiser.' },
    ],
  },
  'loja-de-roupas': {
    slug: 'pdv-para-loja-de-roupas',
    icon: Shirt,
    nome: 'Loja de Roupas',
    title: 'Sistema PDV para Loja de Roupas com NFC-e e Grade | Fácil e Barato',
    description: 'Sistema para loja de roupas fácil e descomplicado: grade de tamanho e cor, etiquetas com código de barras, NFC-e homologada, crediário e catálogo no WhatsApp. Melhor custo-benefício.',
    h1a: 'Sistema PDV para',
    h1b: 'Loja de Roupas',
    sub: 'Controle de grade (tamanho e cor), etiquetas, crediário e cupom fiscal em um sistema simples, bonito de usar e com preço justo.',
    keywords: ['sistema para loja de roupas', 'pdv para boutique', 'sistema com grade tamanho cor', 'programa para loja de roupas nfc-e'],
    dores: [
      'Não saber qual tamanho e cor ainda tem em estoque',
      'Etiquetas manuais e troca de peças sem controle',
      'Crediário anotado em caderno',
      'Sistemas complicados feitos para grandes redes',
    ],
    features: [
      { icon: Package, t: 'Grade tamanho x cor', d: 'Estoque por variação (P/M/G, cores) com visão rápida do que falta repor.' },
      { icon: Tag, t: 'Etiquetas com código de barras', d: 'Imprima etiquetas de preço e leia no caixa em segundos.' },
      { icon: Receipt, t: 'NFC-e homologada', d: 'Cupom fiscal eletrônico na SEFAZ, com troca e devolução controladas.' },
      { icon: Users, t: 'Crediário e clientes', d: 'Contas a receber por cliente, parcelas e lembrete de cobrança pelo WhatsApp.' },
      { icon: MessageCircle, t: 'Catálogo no WhatsApp', d: 'Link do catálogo digital com fotos e bot com IA para tirar dúvidas e vender 24h.' },
      { icon: Truck, t: 'Shopee, Shein e TikTok Shop', d: 'Integre seus marketplaces e centralize os pedidos no mesmo sistema.' },
    ],
    depoimentos: [
      { nome: 'Camila Duarte', negocio: 'Camila Modas', cidade: 'São Paulo/SP', texto: 'Grade de tamanho e cor com etiqueta de código de barras. Sei exatamente o que tenho em estoque sem contar peça por peça.' },
      { nome: 'Renata Oliveira', negocio: 'Boutique Renata', cidade: 'Belo Horizonte/MG', texto: 'Crediário controlado, lembrete de parcela pelo WhatsApp e cupom fiscal em toda venda. E custa menos do que eu pagava.' },
      { nome: 'Thiago Pereira', negocio: 'TP Street Wear', cidade: 'Curitiba/PR', texto: 'Vendo na loja, na Shopee e no catálogo do WhatsApp com o mesmo estoque. Zero venda sem peça.' },
    ],
    logos: ['Camila Modas', 'Boutique Renata', 'TP Street Wear', 'Loja Trend', 'Moda & Estilo'],
    faq: [
      { q: 'Controla grade de tamanho e cor?', a: 'Sim. Cada produto pode ter variações de tamanho e cor com estoque e código de barras próprios.' },
      { q: 'Faz troca e devolução?', a: 'Sim. Controle de trocas com vale-troca e devolução ao estoque automaticamente.' },
      { q: 'Vende online também?', a: 'Sim. Catálogo digital para WhatsApp e integração com Shopee, Shein, TikTok Shop e Mercado Livre.' },
    ],
  },
};

export const SEGMENT_LIST = Object.entries(SEGMENTS).map(([key, s]) => ({ key, ...s }));
export const segmentUrl = (s) => `${BASE}/${s.slug}`;
